// src/components/dashboard/user-requests/utils/requestTransformers.ts
import { AddRequest, PersonalInfoRequest } from '@/types';
import { UserRequest } from '../types/request';

export function transformChildRequests(
  requests: AddRequest[], 
  userId: string
): UserRequest[] {
  return requests
    .filter(req => req.requesterId === userId)
    .map(req => ({
      id: req.id,
      type: 'add_child',
      userId,
      childName: req.childName,
      phoneNumber: req.phoneNumber,
      status: req.status,
      timestamp: req.timestamp
    }));
}

export function transformInfoRequests(
  requests: PersonalInfoRequest[],
  userId: string
): UserRequest[] {
  return requests
    .filter(req => req.requesterId === userId)
    .map(req => ({
      id: req.id,
      type: 'add_info',
      userId,
      status: req.status,
      timestamp: req.timestamp,
      personalInfo: req.personalInfo
    }));
}
